'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResponseWrapper = function () {
    function ResponseWrapper(response, error, disableDeserialize) {
        _classCallCheck(this, ResponseWrapper);

        this.response = response || {};
        this._error = error;
        this.disableDeserialize = disableDeserialize;
    }

    _createClass(ResponseWrapper, [{
        key: 'hasError',
        get: function get() {
            return !!this._error;
        }
    }, {
        key: 'error',
        get: function get() {
            return this._error;
        }

        /* istanbul ignore next */

    }, {
        key: 'status',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'statusType',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'text',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'data',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'headers',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }
    }]);

    return ResponseWrapper;
}();

exports.default = ResponseWrapper;